import { useState } from "react";
import { useParams } from "react-router-dom";

import { useGetPatientWithId } from "@/api/patients";
import PatientProfile from "@/components/patient/patient-profile";
import PatientTabComponent from "@/components/patient/patient-tab";
import PatientTabSelector from "@/components/patient/patient-tab-selector";
import Loader from "@/components/ui/loader";
import type { PatientTab } from "@/types/utils";
import { patientTabChoices } from "@/types/utils";

const PatientPage = () => {
  const { id } = useParams();
  const { data: patient } = useGetPatientWithId(parseInt(id ?? "0"));

  const [selectedTab, setSelectedTab] = useState("DASHBOARD");

  if (!patient) {
    return <Loader />;
  }
  return (
    <div className="flex w-full">
      <PatientProfile patient={patient} />
      <div className="flex flex-col w-full p-8 gap-6">
        <PatientTabSelector
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          choices={patientTabChoices}
        />
        <PatientTabComponent
          selectedTab={selectedTab as PatientTab}
          patient={patient}
        />
      </div>
    </div>
  );
};

export default PatientPage;
